import axios from 'axios'
import firebase from 'firebase';

async function getInitializeData() {
    if (process.env.NODE_ENV === 'production' && window.location.protocol !== 'file:') {
        let response = await axios.get('/__/firebase/init.json');
        return response.data;
    } else {
        return {
            "apiKey": "AIzaSyCaYsndWbNCys9VKl5Dp0xij4MLhYXgdBE",
            "databaseURL": "https://zist-staging.firebaseio.com",
            "storageBucket": "zist-staging.appspot.com",
            "authDomain": "zist-staging.firebaseapp.com",
            "messagingSenderId": "981701164298",
            "projectId": "zist-staging"
        };
    }
}

export default async function() {
    let data = await getInitializeData();
    
    firebase.initializeApp(data);
}



// WEBPACK FOOTER //
// ./src/cloud/firebaseInit.js